export default __webpack_public_path__ + "static/media/newsletter1.e72c2ea9.jpeg";